/* eslint-disable react-hooks/exhaustive-deps */
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import Page from 'components/Page';
import { ambienteAplicacion } from 'constants/urls';
import useCustomRouter from 'hooks/useCustomRouter';
import { TabView } from 'primereact/tabview';
import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router';
import useDetallePoliza from 'redux/hooks/useDetallePoliza';
import Loading from 'wrappers/Loading';
import InformacionPoliza from './components/InformacionPoliza';
import PlanesSeleccionadosPoliza from './components/PlanesSeleccionadosPoliza';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { URLS_PHP_7 } from 'constants/urls_v2';
const DetallePoliza = () => {
  const { idPoliza } = useParams();

  const { setStateDetallePoliza, setPlanSeleccionado, loading, setLoading } =
    useDetallePoliza();

  const router = useCustomRouter();

  const init = useCallback(async () => {
    setLoading(true);

    const Data = {
      datosCotizador: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'detallePoliza',
        idPoliza,
      },
    };

    const res = await ApiKeyFetch.instance().post(URLS_PHP_7.emision.datosEmision, Data);
    console.log('RES: ', res);
    setStateDetallePoliza(res?.catalogo?.datosDetallePoliza);

    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  const planes = PlanesSeleccionadosPoliza();
  //const detallesContratanteSegurado = DetalleContratanteAseguradoPoliza();

  return (
    <Loading loading={loading}>
      <main className="cr-content">
        <Page>
          <BreadCurmb title="Detalle de compra" subtitle="Detalle de compra" />

          <button
            className="btn btn-sm btn-primary"
            onClick={() => {
              router.push(`/listado-polizas-certificados`);
              setPlanSeleccionado(null);
            }}
          >
            Regresar
          </button>

          <InformacionPoliza />

          <div className="row justify-content-center">
            <div className="col-12 col-lg-11">
              <h1>Detalles de la compra</h1>
              <TabView>
                {planes}
                {/* {detallesContratanteSegurado} */}
              </TabView>
            </div>
          </div>
        </Page>
      </main>
    </Loading>
  );
};

export default DetallePoliza;
